<script setup>
import {PhCheck, PhWarning, PhX, PhTag} from '@phosphor-icons/vue';
import QuantityString from "@/Components/QuantityString.vue";

const props = defineProps(['product']);
</script>

<template>
    <div class="flex-col flex" v-if="props.product.quantityAvailable < 5000">
        <template v-if="product.inStock">
            <div v-if="props.product.quantityAvailable <= 2" class="flex-row flex">
                <PhWarning weight="fill" class="h-5 w-5 flex-shrink-0 text-amber-500" aria-hidden="true"/>
                <p class="ml-2 text-sm font-medium text-amber-600">Only
                    <QuantityString :value="props.product.quantityAvailable" :uom="product.uom.stock" />
                    left — order soon!
                </p>
            </div>
            <div v-else class="flex-row flex">
                <PhCheck weight="bold" class="h-5 w-5 flex-shrink-0 text-green-500" aria-hidden="true"/>
                <p class="ml-2 text-sm text-gray-500">
                    <QuantityString :value="props.product.quantityAvailable" :uom="product.uom.stock" />
                    in stock and ready to ship
                </p>
            </div>
        </template>
        <template v-else>
            <div class="flex-row flex">
                <PhX weight="bold" class="h-5 w-5 flex-shrink-0 text-red-600" aria-hidden="true"/>
                <p class="ml-2 text-sm text-gray-500">Out of stock</p>
            </div>
        </template>
        <template v-if="!product.discountable">
            <div class="flex-row flex">
                <PhTag weight="fill" class="h-5 w-5 flex-shrink-0 text-gray-600" aria-hidden="true"/>
                <p class="ml-2 text-sm text-gray-500">Not eligible for Coupon Code discount.</p>
            </div>
        </template>
    </div>
</template>
